import Lang from "@vendors-fr/messages";
import 'jquery-confirm';
import {JconfirmTemplateHelper} from "@plugins-fr/JconfirmTemplateHelper";
import {alertLogin} from "@commons-fr/login";
import {featureRequiredLogin} from "@commons-fr/userStatus";
import {PushAds} from "@commons-fr/pushAds";
import {UserStatusService} from "@commons-fr/userStatusService";

$(document).ready(function(){
    const JS_VARS = JSON.parse(shops);

    const uss = new UserStatusService();
    uss.registerFeature(featureRequiredLogin, {}, function(response){
        if (JS_VARS.loginStatus === 0 && response) {
            alertLogin(response.displayMemberLoginBlock);
        }
    });
    uss.setCallback(function(result){
        // 若在物流詳情頁點擊訂單查詢後登入，則跳轉到訂單明細頁
        if (JS_VARS.isMemberOrder && JS_VARS.loginStatus === 1) {
            let params = new URLSearchParams(location.search);
            if (params.get('login_action') === 'order_query') {
                $('#js_order_query').trigger('submit');
            }
        }

        (new PushAds()).start();
    });

    function copySelectionText (el) {
        var jQueryEl;
        if (el instanceof jQuery) {
            jQueryEl = el;
            el = jQueryEl.get(0);
        } else {
            jQueryEl = $(el);
        }

        if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
            var oldContentEditable = el.contentEditable;
            var oldReadOnly = el.readOnly;
            el.contentEditable = true;
            el.readOnly = false;

            var range = document.createRange();
            range.selectNodeContents(el);

            var s = window.getSelection();
            s.removeAllRanges();
            s.addRange(range);
            el.setSelectionRange(0, el.value.length);
            el.contentEditable = oldContentEditable;
            el.readOnly = oldReadOnly;
        } else {
            jQueryEl.focus();
            jQueryEl.select();
        }

        var copyResult = false;
        try {
            copyResult = document.execCommand("copy");
        } catch (e) {
            copyResult = false;
        }
        jQueryEl.blur();
        return copyResult;
    }

    $('.js_copy_link_button').click(function(){
        var target = $(this).data('target'),
            targetId = $('#' + target);

        var copysuccess = copySelectionText(targetId);
        var message = copysuccess ? Lang.get('frontend.order.serial_no.copy.success') : Lang.get('frontend.order.serial_no.copy.error');
        $.dialog({
            template: JconfirmTemplateHelper.getTemplate({
                'templateType': '01',
                'theme': 'el_confirm'
            }),
            columnClass: 'col-lg-5 col-xl-4',
            content: false,
            closeIcon: false,
            icon: 'icon-new_exclaim_circle',
            title: message,
            offsetTop: 0,
            offsetBottom: 0,
            onOpenBefore: function() {
                var that = this;
                setTimeout(function() {
                    that.close();
                }, 1000);
            }
        });
    });

    $('.js_query_order_button').on('click', () => {
        if (JS_VARS.isMemberOrder && JS_VARS.loginStatus === 0) {
            let params = new URLSearchParams(location.search);

            location.href = '/index/member_login?type=order_query&no=' + params.get('no');
        } else if(JS_VARS.isMemberOrder && JS_VARS.loginStatus === 1) {
            $('#js_order_query').trigger('submit');
        } else {
            location.href = JS_VARS.urls.queryUrl;
        }
    });
});
